import { Box, Grid, Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";

import Table from "components/Table";
import WrapperAmount from "./Component/WrapperAmount";
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

const headers = [
  {
    name: "Coin",
    key: "coin",
  },
  {
    name: "Type",
    key: "type",
  },
  {
    name: "Amount",
    key: "amount",
  },
  {
    name: "Date & Time",
    key: "date",
  },
];

function TableTransferHistory({ historyList }) {
  const formattedDataList = historyList?.data?.map((data) => {
    const isEnter = data?.typeId === 11;
    const isExit = data?.typeId === 14;

    const typeColor = isEnter ? "success.main" : isExit ? "error.main" : "text.main";
    const TypeIcon = isEnter ? LoginIcon : isExit ? LogoutIcon : null;

    return {
      coin: <WrapperAmount data={data} />,
      type: (
        <Box display="flex" alignItems="center" gap={2} dir="rtl" justifyContent={"end"}>
          {TypeIcon && <TypeIcon fontSize="small" color={isEnter ? 'success' : isExit ? 'error' : 'inherit'} sx={{transform: isEnter ? "rotate(180deg)" : "unset"}} />}

          <Typography variant="h5" color={typeColor}>
            {data?.type}
          </Typography>
        </Box>
      ),
      amount: (
        <Typography variant="h5" color="text.main">
          <NumberFormats value={data?.amount} />
        </Typography>
      ),
      date: (
        <Typography variant="h5" color="text.main">
          {data?.date} {data?.time}
        </Typography>
      ),
    };
  });

  return (
    <>
      <Grid item xs={12}>
        <Table headers={headers} items={formattedDataList} hideBorders={true} />
      </Grid>
    </>
  );
}
export default TableTransferHistory;
